export default {
    cancelAllBidsConfirm : "Are you sure you want to cancel All bids?",
    cancelBidConfirm : "Are you sure you want to cancel this bid?",
    quantityUpdated : "Quantity successfully updated.",
    parValueMultipleFiveError: "The Par value have to be multiples of 5.",
    maxOfCusipTooltipText : "Maximum number of different Cusip allowed for a trader to bid.",
    maxParvalueTooltipText : "Maximum quantity of a Cusip allowed for a trader to bid.",
    maxCapitalUpdated  : "Max amount successfully updated.",
    bidValidityUpdated : "Bid validity successfully updated.",
    traderDataUpdated : "Trader data updated",
    cusipStatusChanged : "Cusip status changed",
    addUser : "User Added",
    updateUser : "User details updated",
    bidConfirm : "Are you sure you want to Bid this ?",
    bidUpdate : "Are you sure you want to update this bid?",
    cusipNoCallDate: "This cusip doesn't have a call date",
    cusipNoMaturityDate: "This cusip doesn't have a maturity date ",
    cusipCallDateEqualCurrentYear : "This cusip call date year same as current year",
    cusipMaturityDateEqualCurrentYear : "This cusip maturity date year same as current year",
    maxNumberCusipLimit : "Max number of Cusip limit is reached. Please contact your administrator",
    yiledOrBidpriceMissing : "Please select Yield or Bid price",
    yiledValueMissing : "Yield value is required",
    tmcPriceMissing : "TMC Price is required",
    bidPriceMissing : "Bid price is required",
    parValueMissing : "Par value is required",
    minQtyMissing : "Minimum quantity is required",
    parValueMinQtyMultipleFiveError : "The Par value and the minimum quantity have to be multiples of 5",
    minQtyLessThanParValue : "Minimum quantity has to be less than par value",
    BpsMinGreaterThanMax : "BPS range max value must be greater than min value",
    pointToCurveIsrequired: "Bid point to curve is required.",
    pointToDateIsrequired: "Bid point to date is required.",
    bidFactorRationIsrequired : "Bid factor ratio is required.",
    bidSuccess : "Bid Successful",
    updateAllYields : "Are you sure you want to update all bids yield?",
    updateAllbidPrice : "Are you sure you want to update all bids price?",
    bidCancelSuccess : "All Bids cancelled",
    curveYiledNotValid : "Curve yield value must be greater than zero",
    accountSetSuccess : "Account number successfully updated.",
    tmcAccountNotSetError : "TMC Account is not set",
    yieldValueGreatethanTen : "Yield value must be less than 10",
    bidPriceGreatethan160 : "Bid Price must be less than 160",
}